module.exports = __webpack_public_path__ + "img/task_nodata.24672118.svg";